import { Link } from 'react-router-dom';
import { Mixpanel } from '../../../services/Mixpanel';
import { WithTooltip } from '../../../components/WithTooltip';

function SidebarItem({
  icon: Icon,
  label,
  to,
  href,
  external,
  onClick,
  isExpanded,
  root,
  children,
  tooltipDisabled = false,
}) {
  const handleClick = (e) => {
    Mixpanel.track('Sidebar click', { item: label });
    // With `to`, <Link> navigates after this unless onClick prevented default,
    // and leaves modifier/middle clicks to the browser (new tab).
    if (onClick) onClick(e);
  };

  const Tag = root ?? (href ? 'a' : to ? Link : 'button');
  const linkProps = href
    ? { href, ...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {}) }
    : to
      ? { to }
      : { type: 'button' };

  const content = (
    <Tag
      {...linkProps}
      onClick={handleClick}
      className={`group flex items-center rounded-lg text-sm transition-colors text-gray-600 hover:bg-gray-200 hover:text-gray-900 px-2 py-1.5 w-full ${
        isExpanded ? 'gap-x-2' : ''
      }`}>
      <Icon className='h-5 w-5 flex-shrink-0' />
      <span
        className={`truncate whitespace-nowrap transition-opacity duration-300 ${
          isExpanded ? 'opacity-100' : 'opacity-0 w-0 overflow-hidden'
        }`}>
        {label}
      </span>
      {children}
    </Tag>
  );

  return (
    <WithTooltip
      disabled={isExpanded || tooltipDisabled}
      text={label}
      position='right'
      showArrow
      usePortal
      zIndex={55}>
      {content}
    </WithTooltip>
  );
}

export default SidebarItem;
